import styled from "styled-components";
import { Table as ANTDTable } from "antd";

export const AccountTable = styled(ANTDTable)`
    border-radius: 12px;
    box-shadow: 0 8px 42px 0 rgba(0, 33, 92, 0.08);
    background-color: #ffffff;
    padding: 12px;
    margin-top: 16px;

    .anticon {
        vertical-align: text-top;
    }

    .ant-pagination.mini .ant-pagination-prev, .ant-pagination.mini .ant-pagination-next {
        background-color: #e9ecf2;
        border: solid 1px #e9ecf2;
        margin: 0 8px;
    }

    .ant-pagination.mini .ant-pagination-prev:hover, .ant-pagination.mini .ant-pagination-next:hover {
        border: solid 1px #2e3c50;
        color: #2e3c50;
    }

    .ant-pagination.mini .ant-pagination-prev:focus, .ant-pagination.mini .ant-pagination-next:focus {
        border: solid 1px #2e3c50;
        color: #2e3c50;
    }

    .ant-pagination.mini .ant-pagination-item:not(.ant-pagination-item-active) {
        background-color: #e9ecf2;
        border: solid 1px #e9ecf2;
    }

    .ant-pagination.mini .ant-pagination-item:not(.ant-pagination-item-active):hover {
        border: solid 1px #2e3c50;
        color: #2e3c50;
    }

    .ant-pagination.mini .ant-pagination-item:not(.ant-pagination-item-active):focus {
        border: solid 1px #2e3c50;
        color: #2e3c50;
    }

    .ant-pagination-item-active {
        color: #ffffff;
    }

    .ant-pagination-options {
        float: right;
    }

    .ant-select:not(.ant-select-customize-input) .ant-select-selector:hover {
        border: 1px solid #2e3c50;
    }

    .ant-select:not(.ant-select-customize-input) .ant-select-selector:focus {
        border: 1px solid #2e3c50;
    }

    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
        background-color: #e9ecf2;
    }

    .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
        box-shadow: none;
        border: 1px solid #2e3c50;
    }

    .ant-table .ant-table-tbody > tr:hover > td {
        background: ${props => props.unsetRowHover ? "unset" : "#fafafa"};
    }
`;